import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import { store } from "./store/store";
import vuetify from "./plugins/vuetify/vuetify";
import * as dotenv from "dotenv";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import "@/plugins/directives.js";

declare global {
  interface Node {
    readonly children: HTMLCollection;
  }
}

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

dotenv.config();

Vue.config.productionTip = false;

const vue_application = new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App)
});

vue_application.$mount("#app");
